import React from "react";
import {Location, User} from "../types/Types";
import UserVisits from "./tabs/UserVisits";

interface Props {
    locations: Array<Location> | undefined,
    currentUser: User | undefined,
}

function MyProfile(props: Props) {
    return (
        <UserVisits currentUser={props.currentUser} locations={props.locations} />
    );
}

export default MyProfile;